import React, { useCallback } from 'react';
import { WidthObserver } from '@atlaskit/width-detector';
import {
  OverflowProvider,
  useOverflowController,
  NavigationItem,
} from './useOverflowController';
import styles from './HeaderPrimaryNavigationItems.less';
import { LazyMoreMenu } from 'app/src/components/MoreMenu';
import { WorkspaceSwitcher } from 'app/src/components/WorkspaceSwitcher';
import { RecentlyViewedBoardsMenuButton } from 'app/src/components/RecentlyViewedBoardsMenu';
import { StarredBoardsMenuButton } from 'app/src/components/StarredBoardsMenu';
import { TemplatesMenu } from 'app/src/components/TemplatesMenu';
import { CreateMenuButton } from 'app/src/components/Header/CreateMenuButton';
import { TacoAnnouncements } from 'app/src/components/TacoAnnouncements';

export const HeaderPrimaryNavigationItems = () => {
  const navigationItems: NavigationItem[] = [
    {
      name: 'WorkspaceSwitcher',
      component: <WorkspaceSwitcher key="WorkspaceSwitcher" />,
    },
    {
      name: 'RecentlyViewedBoardsMenu',
      component: (
        <RecentlyViewedBoardsMenuButton key="RecentlyViewedBoardsMenu" />
      ),
    },
    {
      name: 'StarredBoardsMenuButton',
      component: <StarredBoardsMenuButton key="StarredBoardsMenuButton" />,
    },
    {
      name: 'TemplatesMenu',
      component: <TemplatesMenu key="TemplatesMenu" />,
    },
  ];
  const { updateWidth, visibleItems, overflowItems } = useOverflowController(
    navigationItems,
  );

  const WidthObserverRelativeWrapper = () => {
    return (
      <div className={styles.widthObserverContainerStyle}>
        <WidthObserver offscreen={true} setWidth={updateWidth} />
      </div>
    );
  };

  const content = useCallback(
    () => {
      const names = overflowItems.map((item) => {
        return item.name;
      });

      return (
        <OverflowProvider isVisible={false}>
          <LazyMoreMenu menuItems={names} />
        </OverflowProvider>
      );
    },

    // moreMenuItems  has an unstable reference - so we will only recalculate
    // content if `moreMenuItems` length changes.
    // eslint-disable-next-line @trello/exhaustive-deps
    [overflowItems.length],
  );

  return (
    <div className={styles.containerCSS}>
      <div>
        <OverflowProvider isVisible>
          {visibleItems.map((item) => item.component)}
        </OverflowProvider>
        {overflowItems.length > 0 && <>{content()}</>}
      </div>
      <CreateMenuButton />
      <TacoAnnouncements />
      <WidthObserverRelativeWrapper />
    </div>
  );
};
